<template>
  <el-col>
    <w-timeline-chart :active="active" @clickChart="onClickChart"/>
    <component v-for="chartView in templateCharts" :key="chartView.templateId" :is="chartView.componentName" :active="active" :chartVisible="true" @clickChart="onClickChart" @clickAddButton="onClickAddButton"/>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import AnalysisMixin from '@/mixins/performance/analysis';
import perfCommonApi from '@/api/performance/common';

import WTimelineChart from '@/views/performance/node/analysis/components/TimelineChart';

import WHostClusterCpuAnalysisChart from './components/chart/HostClusterCpuAnalysisChart';
import WHostClusterMemAnalysisChart from './components/chart/HostClusterMemAnalysisChart';
import WHostClusterNetIoAnalysisChart from './components/chart/HostClusterNetIoAnalysisChart';

import WHostCpuAnalysisChart from './components/chart/HostCpuAnalysisChart';
import WHostMemAnalysisChart from './components/chart/HostMemAnalysisChart';
import WHostDiskIoAnalysisChart from './components/chart/HostDiskIoAnalysisChart';
import WHostNetIoAnalysisChart from './components/chart/HostNetIoAnalysisChart';

import WVmCpuAnalysisChart from './components/chart/VmCpuAnalysisChart';
import WVmMemAnalysisChart from './components/chart/VmMemAnalysisChart';
import WVmDiskAnalysisChart from './components/chart/VmDiskAnalysisChart';
import WVmDiskIoAnalysisChart from './components/chart/VmDiskIoAnalysisChart';
import WVmNetIoAnalysisChart from './components/chart/VmNetIoAnalysisChart';

import WStorageClusterDiskAnalysisChart from './components/chart/StorageClusterDiskAnalysisChart';
import WStorageDiskAnalysisChart from './components/chart/StorageDiskAnalysisChart';

export default {
  name: 'WPerformanceVirtualAnalysisChart',
  components: {
    WTimelineChart,
    WHostClusterCpuAnalysisChart,
    WHostClusterMemAnalysisChart,
    WHostClusterNetIoAnalysisChart,
    WHostCpuAnalysisChart,
    WHostMemAnalysisChart,
    WHostDiskIoAnalysisChart,
    WHostNetIoAnalysisChart,
    WVmCpuAnalysisChart,
    WVmMemAnalysisChart,
    WVmDiskAnalysisChart,
    WVmDiskIoAnalysisChart,
    WVmNetIoAnalysisChart,
    WStorageClusterDiskAnalysisChart,
    WStorageDiskAnalysisChart,
  },
  mixins: [AnalysisMixin],
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (!this.active || isEmpty(node)) {
          return;
        }
        this.$store.dispatch('setPlotLineDatetime', null);
        this.loadData();
      },
    },
  },
  methods: {
    loadData() {
      if (!isEmpty(this.templateCharts)) {
        map(this.templateCharts, (record) => {
          record.visible = false;
        });
      }
      const obj = this.selectedNode.obj;
      const params = {
        managetypeId: obj.objManagetypeId,
        objtypeId: this.selectedNode.hypervisorType,
        managetypeKey: obj.objtypeId,
      };

      perfCommonApi.getPerfChartTypeByMgr(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const templateCharts = [];

          const hypervisorType = this.selectedNode.hypervisorType;
          result.forEach((record) => {
            // FIXME: 설계 완료 후 parameter로 managetypeId를 넘길 것이므로 managetypeId 비교 로직 뺄것.
            if (record.managetypeId === 'VMS' && record.objtypeId === hypervisorType) {
              templateCharts.push({
                componentName: `W${upperFirst(camelCase(record.chartTypeId))}AnalysisChart`,
                templateId: record.chartTypeId,
                visible: true,
              });
            }
          });
          this.templateCharts = templateCharts;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/virtual/PerformanceVirtualAnalysisChart.vue